import type { AnchorHTMLAttributes } from "react";

export function LocalizedAnchor(props: AnchorHTMLAttributes<HTMLAnchorElement>) {
	return <a {...props} />;
}
